import React from 'react';
import SectionTitle from './SectionTitle';

const pearlData = {
  white: {
    description: `<p>White South Sea pearls are known for their luxurious elegance. Sourced from the pristine waters of Australia, these pearls are prized for their exceptional size, creamy-white hue, and silky luster. Their natural iridescence and smooth surface make them the ultimate choice for creating timeless jewelry pieces.</p>
                  <p>At MIRA PEARLS, we offer a variety of White South Sea pearls for wholesale, including: Loose pearls in multiple sizes and shapes, Custom-selected pearl strands and High-quality pearl jewelry. Our customized wholesale solutions ensure your designs are tailored to your exact needs.</p>
                  <p><b>Partner with MIRA PEARLS for your source of premium White South Sea pearls.</b></p>
                  `,
    items: [
      { image: "/images/white-section-01.png" },
      { image: "/images/white-section-02.png" },
      { image: "/images/white-section-03.png" }
    ]
  },
  golden: {
    description: `<p>Golden South Sea pearls are one of the rarest and most sought-after pearls globally, celebrated for their natural, rich golden tones. Harvested from the waters of the Philippines and Indonesia, they offer a warm, luxurious glow that makes them perfect for creating bold and sophisticated jewelry.</p>
                  <p>At MIRA PEARLS, we provide a curated selection of Golden South Sea pearls, including loose pearls in varied shapes, sizes, and golden hues, exquisite pearl strands for fine jewelry and Golden South Sea jewelry. We also offer customized wholesale services to ensure you get the perfect pearls for your collection.</p>
                  <p><b>Partner with MIRA PEARLS for the finest Golden South Sea pearls.</b></p>
                  `,
    items: [
      { image: "/images/golden-section-01.png" },
      { image: "/images/golden-section-02.png" },
      { image: "/images/golden-section-03.png" }
    ]
  },
  black: {
    description: `<p>Tahitian pearls, often called Black Pearls, are known for their vibrant, exotic colors and stunning iridescent sheen. These pearls, harvested from French Polynesia, range from deep charcoal to brilliant peacock greens, offering a unique alternative to more traditional white pearls. Their bold colors and striking appearance make them ideal for creating contemporary, statement jewelry.</p>
                  <p>At MIRA PEARLS, we offer a broad selection of Tahitian pearls, including loose pearls in a variety of shapes, sizes, and colors, hand-selected pearl strands and Tahitian pearl jewelry. We also provide customized wholesale solutions to suit your business’s needs.</p>
                  <p><b>Partner with MIRA PEARLS for high-quality Tahitian pearls.</b></p>
                  `,
    items: [
      { image: "/images/hahitian-section-01.png" },
      { image: "/images/hahitian-section-02.png" },
      { image: "/images/hahitian-section-03.png" }
    ]
  }
};

const getContainerBgColor = (type) => {
  switch(type) {
    case 'white':
      return '#ffffff';
    case 'golden':
      return '#f5f5f5';
    case 'black':
      return '#ffffff';
    default:
      return '#ffffff';
  }
};

const PearlSection = ({ type, title }) => {
  return (
    <section id={`${type}-pearls`} className="section pt-5 mt-5">
      <div className="container">
        <SectionTitle title={title} />
        
        {/* Description text */}
        <div className="row mb-5">
          <div className="col-md-8 mx-auto">
            <div 
              style={{ 
                whiteSpace: 'pre-line',
                textAlign: 'justify'
              }}
              dangerouslySetInnerHTML={{ __html: pearlData[type].description }}
            />
          </div>
        </div>

        {/* Pearl cards */}
        <div className="row">
          {pearlData[type].items.map((item, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="card">
                <div style={{ backgroundColor: getContainerBgColor(type) }}>
                  <img 
                    src={item.image} 
                    className="card-img-top" 
                    alt="Pearl"
                    style={{
                      width: '100%',
                      height: '300px',
                      objectFit: 'cover'
                    }} 
                  />
                </div>
                {/* Removed card-body div with title */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PearlSection;